const hasCryptoUUID = typeof crypto !== 'undefined' && !!crypto.randomUUID
export function uuid(): string {
  if (hasCryptoUUID) return crypto.randomUUID()
  // fallback simples
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const ANON_KEY = '__anid'
export const SESS_KEY = '__sid'

export function getAnonId(): string {
  try {
    const v = localStorage.getItem(ANON_KEY)
    if (v) return v
    const n = uuid()
    localStorage.setItem(ANON_KEY, n)
    return n
  } catch {
    return uuid()
  }
}

export function getSessionId(): string {
  try {
    const v = sessionStorage.getItem(SESS_KEY)
    if (v) return v
    const n = uuid()
    sessionStorage.setItem(SESS_KEY, n)
    return n
  } catch {
    return uuid()
  }
}

// Force a new session (e.g. on logout via Analytics.reset()) so events from
// the next user don't get attributed to the previous user's session.
export function resetSessionId(): string {
  const n = uuid()
  try {
    sessionStorage.setItem(SESS_KEY, n)
  } catch {
    /* noop */
  }
  return n
}
